// PR chat pembeli: keadaan chat untuk kode di luar komponen React (toast keranjang, penerjemah pesan server). Penentunya tetap server (GET /api/chat/status).
const keadaan = { aktif: false, buka: null };
export const aturChat = (x) => { Object.assign(keadaan, x); };
export const chatAktif = () => keadaan.aktif;
export const bukaChat = (konteks) => { if (keadaan.buka) keadaan.buka(konteks); };
/** Kalimat yang menyebut WhatsApp → chat, hanya untuk pembeli yang chat-nya aktif. */
export const teksKontak = (s) => {
  if (!keadaan.aktif || typeof s !== "string") return s;
  return s.replace(/\b(?:melalui|lewat|via) WhatsApp\b/g, "melalui chat").replace(/\bChat WhatsApp\b/g, "Chat");
};
